import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { businessInfo } from '../mock';

export const Footer = () => {
  return (
    <footer className="bg-slate-950 text-gray-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_key-cut-prog/artifacts/4nlb8wby_image.png"
              alt="SM Engineering Auto Locksmith & Diagnostics"
              className="h-16 w-auto mb-4"
            />
            <p className="text-sm text-gray-400 mb-4">
              Professional key cutting, programming and emergency locksmith services across Cambridgeshire and surrounding areas.
            </p>
            <div className="flex items-center space-x-2 text-blue-400">
              <Clock className="w-4 h-4" />
              <span className="text-sm font-semibold">{businessInfo.hours}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/key-services" className="text-sm hover:text-blue-400 transition-colors">
                  Key Programming & Replacement
                </Link>
              </li>
              <li>
                <Link to="/lockouts" className="text-sm hover:text-blue-400 transition-colors">
                  Emergency Lockout Service
                </Link>
              </li>
              <li>
                <Link to="/emergency" className="text-sm hover:text-blue-400 transition-colors">
                  24/7 Emergency Callout
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-blue-400 mt-0.5 flex-shrink-0" />
                <div>
                  <a 
                    href={`tel:${businessInfo.phone}`} 
                    className="text-sm hover:text-blue-400 transition-colors font-semibold"
                  >
                    {businessInfo.phone}
                  </a>
                  <p className="text-xs text-gray-500">Click to call</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-blue-400 mt-0.5 flex-shrink-0" />
                <div>
                  <a 
                    href={`mailto:${businessInfo.email}`} 
                    className="text-sm hover:text-blue-400 transition-colors"
                  >
                    {businessInfo.email}
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-blue-400 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm">{businessInfo.location}</p>
                  <p className="text-xs text-gray-500 mt-1">{businessInfo.serviceArea}</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Service Areas</h3>
            <ul className="space-y-1 text-sm">
              <li className="flex items-center space-x-2">
                <span className="w-1.5 h-1.5 bg-blue-400 rounded-full"></span>
                <span>Cambridge</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-1.5 h-1.5 bg-blue-400 rounded-full"></span>
                <span>King's Lynn</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-1.5 h-1.5 bg-blue-400 rounded-full"></span>
                <span>Peterborough</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-1.5 h-1.5 bg-blue-400 rounded-full"></span>
                <span>Bury St Edmunds</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-1.5 h-1.5 bg-blue-400 rounded-full"></span>
                <span>Norwich</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-1.5 h-1.5 bg-blue-400 rounded-full"></span>
                <span>March</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-1.5 h-1.5 bg-blue-400 rounded-full"></span>
                <span>Surrounding Areas</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-500">
              © {new Date().getFullYear()} {businessInfo.name}. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm text-gray-500">
              <button className="hover:text-blue-400 transition-colors">Privacy Policy</button>
              <button className="hover:text-blue-400 transition-colors">Terms of Service</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
